import axios from 'axios';
import React from 'react';
import { Component } from 'react';
import { baseURL } from '../../../constants/applicationConstants.js';
import { fetchArticleDataFromAPI, fetchIdFromName } from '../../../shared/helper.js';
import { Loader } from '../../common/loader/loader.jsx';
import RealEstateJsx from './category.jsx';

export default class RealEstate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            offerData: null,
            fullOfferData: null,
            productData: null,
            adData: null,
            allAdData: null,
            expertData: null,
            categoryData: null,
            subCategoryData: null,
            instituteData: null,
            blogData: null,
            isProcessing: false,
            page: 1,
            mainCatID: "",
            userData: {
                productType: '0',
                productName: '',
                adType: '20',
            },
            formError: {},
            formSubmitButtonDisable: false,
        };
    }

    componentDidMount = async () => {
        // Example values for currentTime and updatedTime
        const currentTime = new Date(); // Get the current time
        const updatedTime = new Date(sessionStorage.getItem('updatedTime')); // Get updated time from sessionStorage

        

        // Compare if the current time is greater than the updated time
        if (currentTime > updatedTime) {
            // Trigger the alert if the current time is greater than the updated time
            sessionStorage.clear();
            
        } else {
        }

        this.setState({ isLoading: true, isProcessing: true });
        sessionStorage.removeItem("selectCategory");

        const fetchedDataId = await fetchIdFromName(this.props.match.params.type); // (cat, type, page)
        sessionStorage.setItem("currentCatId", fetchedDataId);
        sessionStorage.setItem("catPageName", `${this.props.match.params.type}`);
        const mainCategory = fetchedDataId === 2 ? "investment" : fetchedDataId === 5 ? "real-estate" : fetchedDataId === 3 ? "mortgage" : fetchedDataId === 4 ? "banking" : fetchedDataId === 1 ? "insurance" : null;

        this.setState({ mainCatID: fetchedDataId });

        if (this.state.mainCatID) {
            this.getOfferData(mainCategory); // pass category to each data fetch function
            this.getProductData(mainCategory);
            this.getAdData(mainCategory);
            this.getExpertData(mainCategory);
            this.getInstituteData(mainCategory);
        } else {
            window.location.reload();
        }

        const fetchedData = await fetchArticleDataFromAPI(mainCategory, "", this.state.page,"",10);
        this.setState({ blogData: fetchedData.data.data, mainCatID: fetchedDataId });
    };

    // Helper function to get the category-wise sessionStorage key
    getStorageKey = (category, dataType) => {
        return `${category}${dataType}Data`; // Example: 'investmentOfferData'
    };

    // Generic function to get data from sessionStorage or API
    getData = (category, dataType, apiUrl, setStateCallback) => {
        const storageKey = this.getStorageKey(category, dataType);
        const storedData = sessionStorage.getItem(storageKey);

        if (storedData) {
            this.setState({ [dataType]: JSON.parse(storedData), isProcessing: false });
        } else {
            // Get the current time
            const currentTimeAdd = new Date();
            const currentTime = new Date();
            // Add one hour to the current time
            currentTimeAdd.setMinutes(currentTimeAdd.getMinutes() + 59);

            // Convert the updated time to a locale string
            const updatedTime = currentTimeAdd.toLocaleString();

            // Store the updated time in sessionStorage
            sessionStorage.setItem('updatedTime', updatedTime);
            sessionStorage.setItem('currentTime', currentTime.toLocaleString());


            this.setState({ isProcessing: true });

            axios.get(`${baseURL}${apiUrl}?institutionCategoryId=${this.state.mainCatID}`)
                .then(res => {
                    const data = res.data.data;
                    sessionStorage.setItem(storageKey, JSON.stringify(data));
                    this.setState({
                        [dataType]: data,
                        isProcessing: false,
                    });
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    this.setState({ isProcessing: false });
                });
        }
    };

    getOfferData = (category) => {
        this.getData(category, 'offerData', '/featuredOffers', this.setState);
    };

    getProductData = (category) => {
        this.getData(category, 'productData', '/featuredProducts', this.setState);
    };

    getAdData = (category) => {
        this.getData(category, 'adData', '/featuredAds', this.setState);
    };

    getExpertData = (category) => {
        this.getData(category, 'expertData', '/featuredExperts', this.setState);
    };

    getInstituteData = (category) => {
        this.getData(category, 'instituteData', '/featured-institutes', this.setState);
    };

    onInputChangeHandler = (e) => {
        let name = e.target.name;
        let value = e.target.value;

        if (value) {
            if (!this.inputRegexValidation(name, value)) {
                this.setState(
                    {
                        userData: {
                            ...this.state.userData,
                            [name]: value,
                        },
                        formError: {
                            ...this.state.formError,
                            [name]: "regx",
                        },
                    },
                    () => this.isFromSubmissionBlock()
                );
            } else {
                this.setState(
                    {
                        userData: {
                            ...this.state.userData,
                            [name]: value,
                        },
                        formError: {
                            ...this.state.formError,
                            [name]: "",
                        },
                    },
                    () => this.isFromSubmissionBlock()
                );
            }
        } else {
            this.setState(
                {
                    userData: {
                        ...this.state.userData,
                        [name]: value,
                    },
                    formError: {
                        ...this.state.formError,
                        [name]: "",
                    },
                },
                () => this.isFromSubmissionBlock()
            );
        }
    };

    // Other methods remain the same as before...

    render() {
        return (
            <div>
                <RealEstateJsx
                    userData={this.state.userData}
                    subCategoryData={this.state.subCategoryData}
                    offerData={this.state.offerData}
                    productData={this.state.productData}
                    adData={this.state.adData}
                    expertData={this.state.expertData}
                    instituteData={this.state.instituteData}
                    blogData={this.state.blogData}
                    onTouchHandler={this.onTouchHandler}
                    onInputChangeHandler={this.onInputChangeHandler}
                    formError={this.state.formError}
                    onOfferSearchButtonClick={this.onOfferSearchButtonClick}
                    onAdSearchButtonClick={this.onAdSearchButtonClick}
                    onExpertClick={this.onExpertClick}
                    onInstituteClick={this.onInstituteClick}
                    mainCatID={this.state.mainCatID}
                />
                {this.state.isProcessing && <Loader />}
            </div>
        );
    }
}
